import React from "react";
import { BsPlug } from "react-icons/bs";
import { Clipboard } from "react-feather";
import excel from "../feature/excel.png";
import shopify from "../feature/shopify.png";
import woo from "../feature/woo.webp";
import gcloud from "../feature/gcloud.png";

import logo from '../logo.svg';

const IntegrationSection = () => {
  return (
    <div className="col-12 text-center mt-4 pt-6indx0 bg-lblue py-5 mb-2 fade-section">
      <div className="container text-center mb-5 pt-4" style={{ margin: "0 auto",maxWidth:"700px" }}>
        <h1 className="mb-2 mt-4 fw800">
            <b>
                Works with how you already{" "}
                <span className="bg-gold-yellow">run your business</span>
            </b>
        </h1>
        
        <p className="text-muted mt-3 fw-bold">
          Don’t change your system.<br/> Kadhr sits on top of it.
        </p>
      </div>

      <div className="container pb-4" style={{ margin: "0 auto",maxWidth:"800px" }}>
        <div className="row g-4">
            {/* Offline Vendors */}
            <div className="col-md-6">
                <div className="integration-card card-offline p-4 rounded-4 h-100 text-start">

                    <div className="icon-badge mb-5">
                    <Clipboard/>
                    </div>

                    <h4 className="fw800">Still Selling Offline?</h4>
                    <h6 className="fw-bold">Start managing your business on Kadhr.</h6>

                    <p className="text-muted font9 mb-5">
                    Accept payments, Manage stock, track customers, and run your business from one simple system.
                    </p>

                    {/* Mini UI */}
                    <div className="mb-0">
                        <div className="me-2">
                            <img src={logo} alt="#" width="118px" className="bg-white p-2 br10" />
                        </div>
                    </div>

                </div>
            </div>
            {/* Online Vendors */}
            <div className="col-md-6">
            <div className="integration-card card-online p-4 rounded-4 h-100 text-start">

                <div className="icon-badge mb-5">
                <BsPlug className="wh3232"/>
                </div>

                
                <h4 className="fw800">Already Selling Online?</h4>
                <h6 className="fw-bold">Plug Kadhr into how you already sell.</h6>

                <p className="text-muted font9 mb-5">
                    Works with POS, Shopify, WooCommerce, Spreadsheets, Data Warehouse and Custom API Integrations.
                </p>

                {/* Mini UI */}
                <div className="">
                        <div className="icon-badge bg-white mb-3 float-left me-2">
                            <img src={excel} alt="#" width="32px" height="32px"/>
                        </div>
                        <div className="icon-badge bg-white float-left mb-3 me-2">
                            <img src={woo} alt="#" width="32px" height="32px"/>
                        </div>
                        <div className="icon-badge bg-white float-left mb-3 me-2">
                            <img src={gcloud} alt="#" width="32px" height="32px"/>
                        </div>
                        <div className="icon-badge bg-white float-left mb-3 me-2">
                            <img src={shopify} alt="#" width="32px" height="32px"/>
                        </div>
                </div>

            </div>
            </div>
        </div>
      </div>

      {/* subtle background lines (optional aesthetic) */}
      <div className="integration-bg"></div>
    </div>
  );
};

export default IntegrationSection;